import { Button, Input } from '@mui/material'
import React, { ChangeEventHandler } from 'react'

type UploadButtonProps = {
  name: string
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
  disabled?: boolean
}

export const UploadButton: React.FC<UploadButtonProps> = ({ name, onChange, disabled }) => {
  return (
    <>
      <Input
        id={`${name}Id`}
        type='file'
        style={{ display: 'none' }}
        inputProps={{
          accept: '.png, .pdf, .jpg, .jpeg',
        }}
        onChange={onChange}
        disabled={disabled}
      />

      <label htmlFor={`${name}Id`}>
        <Button
          variant='contained'
          color='primary'
          sx={{
            minWidth: 224,
            pl: 2,
            pr: 2,
            borderRadius: 50,
            minHeight: 40,
          }}
          component='span'
          disabled={disabled}
        >
          Anexar Documento
        </Button>
      </label>
    </>
  )
}
